import { styled } from "@vitality-ds/system";
import { BaseAdornmentTextStyles } from "./styles/BaseAdornmentText.styles";

// eslint-disable-next-line import/prefer-default-export
export var AdornmentText = styled("span", BaseAdornmentTextStyles);